import type { Path } from "react-router-dom";

export const RETURN_PATH_PARAM = "returnTo";

export function createLocationPath(location: Partial<Path>) {
  return [location.pathname, location.search, location.hash]
    .filter((p) => p)
    .join("");
}

function combineQueryParams(prev: string | undefined, params: URLSearchParams) {
  if (!prev) return params.toString();

  const combined = new URLSearchParams(prev);
  params.forEach((v, k) => combined.append(k, v));
  return combined.toString();
}

export function addLocationObjectQueryParam(
  location: Partial<Path>,
  params: URLSearchParams,
) {
  const { search, ...rest } = location;

  return {
    ...rest,
    search: `?${combineQueryParams(search, params)}`,
  };
}
